import { useApolloClient } from "@apollo/client/react";
import DataTable from "@mostrans/web-components/components/advanced/DataTable";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { DeleteMasterLokasiInterviewById } from "../../../GQL/mutations";
import Title from "../../../components/Layout/Title";
import { titleAtoms } from "../../../shared/atoms/titleAtoms";
import { useGetMasterLokasiInterview } from "../../../shared/hooks/useGetMasterData";
import ModalCreateOfficeLoc from "./ModalCreateOfficeLoc";
import ModalDetailOfficeLoc from "./ModalDetailOfficeLoc";

function OfficeLocation() {
  const setTitle = useSetRecoilState(titleAtoms);
  const [listMasterLokasiInterview, fetchMasterLokasiInterview] =
    useGetMasterLokasiInterview();
  const [valueSearchByName, setValueSearchByName] = useState("");
  const [openModalDetailOffice, setOpenModalDetailOffice] = useState(false);
  const [detailOfficeLocation, setDetailOfficeLocation] = useState([]);
  const [disableButton, setDisableButton] = useState(true);
  const [errInput, setErrInput] = useState(false);
  const { showConfirmationModal } = useConfirmationModal();
  const client = useApolloClient();

  useEffect(() => {
    setTitle("Office Location");
  }, []);

  const handleOpenModalDetailOffice = async (data) => {
    await setDetailOfficeLocation(data);
    setOpenModalDetailOffice(true);
  };

  const handleCloseModalDetailOffice = () => {
    setOpenModalDetailOffice(false);
    setDisableButton(true);
    setErrInput(false);
  };

  const handleDeleteOfficeLoc = async (idLoc) => {
    const show = await showConfirmationModal({
      contentText: (
        <p style={{ fontSize: 15 }}>Are you sure to delete Office Location?</p>
      ),
    });
    if (show.isConfirmed) {
      try {
        const response = await DeleteMasterLokasiInterviewById(
          client,
          idLoc.id
        );
        if (response.data.deleteMasterLokasiInterviewById.errMsg === "OK") {
          toast.success("Office Location Deleted", {
            position: toast.POSITION.TOP_RIGHT,
          });
          fetchMasterLokasiInterview();
        } else {
          toast.error(response.data.deleteMasterLokasiInterviewById.errMsg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        alert(error);
      }
    }
  };

  const column = [
    {
      getCellKey: (data) => <p key={data.id}>{data?.nama}</p>,
      selector: "nama",
      header: "Office Name",
      sortBy: "office_name",
      sortable: true,
    },
    {
      //  getCellKey: (data) => <p key={data.id}>{data?.alamat}</p>,
      selector: "alamat",
      header: "Office Address",
      sortBy: "office_address",
      sortable: true,
    },
    {
      renderCell: (data) => (
        <React.Fragment key={data.id}>
          <Button onClick={() => handleOpenModalDetailOffice(data)}>
            Detail
          </Button>
          <Button color="error" onClick={() => handleDeleteOfficeLoc(data)}>
            Delete
          </Button>
        </React.Fragment>
      ),
      selector: "id",
      header: "Action",
    },
  ];

  const filterOffice = () => {
    const filteredOffice = listMasterLokasiInterview.filter((office) => {
      return office.nama.toLowerCase().match(valueSearchByName.toLowerCase());
    });
    return filteredOffice;
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {/* <ConfirmDelete /> */}
      <ModalDetailOfficeLoc
        openModalDetailOffice={openModalDetailOffice}
        handleCloseModalDetailOffice={handleCloseModalDetailOffice}
        detailOfficeLocation={detailOfficeLocation}
        disableButton={disableButton}
        setDisableButton={setDisableButton}
        errInput={errInput}
        setErrInput={setErrInput}
        fetchMasterLokasiInterview={fetchMasterLokasiInterview}
      />
      <Paper
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Title>Office Location Master</Title>
        <div className="form-row">
          <div className="col-md-6">
            <FormGroup>
              <Input
                placeholder="Search By Office Name"
                onChange={(e) => setValueSearchByName(e.target.value)}
              />
            </FormGroup>
          </div>
          <div
            className="col md-6"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <ModalCreateOfficeLoc
              fetchMasterLokasiInterview={fetchMasterLokasiInterview}
            />
          </div>
        </div>
        <div className="mt-1">
          <DataTable
            data={filterOffice()}
            columns={column}
            hasPagination={true}
            headerRowStyle={() => ({ fontSize: 13 })}
            conditionalRowStyle={() => ({ fontSize: 13 })}
          />
        </div>
      </Paper>
    </React.Fragment>
  );
}

export default OfficeLocation;
